/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-13 15:00:00
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { Field , reduxForm, reset} from 'redux-form';
import { connect } from 'react-redux';
import * as themeRevertAction from 'actions/theme-revert-actions';

type Props = {
  active: boolean,
  removing: boolean,
  handleClose: () => void,
};

type ComposedProps = Props & WithI18nProps;

class ContactOurTeamThemeRevertModal extends Component<ComposedProps> {

  handleSubmit = (data) => {
    const { dataSetup } = this.props;
    const { sendThemeRevertContactOurTeamManual } = this.props;
    sendThemeRevertContactOurTeamManual({
      ...data,
      themeId: _.get(dataSetup, 'theme.id', ''),
      themeName: _.get(dataSetup, 'theme.name', ''),
    });
  }

  render() {
    const { i18n, active, handleSubmit, loading } = this.props;
    return (
      <Modal
        large
        open={active}
        onClose={this.handleClose}
        title={i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.manual_btn')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.submit'),
          onAction: handleSubmit(this.handleSubmit.bind(this)),
          loading
        }}
      >
        <Modal.Section>
          <TextContainer>
            <TextStyle>
              {i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.contact_hint')}
            </TextStyle>
            <Field
              name="content"
              component={RenderTextField}
              anotherProps={{ multiline: 5 }}
            />
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleClose = () => {
    this.props.handleClose();
  };
}

const ContactOurTeamThemeRevertModalForm = reduxForm({
  form: 'ContactOurTeamThemeRevert', // a unique identifier for this form
  enableReinitialize: true
})(ContactOurTeamThemeRevertModal);

const mapStateToProps = (state, props) => ({
  loading: _.get(state.themeRevert, 'manualContactLoading', false),
  success: _.get(state.themeRevert, 'manualContactSuccess', false),
  error: state.setup.error
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  sendThemeRevertContactOurTeamManual: (body: Object) =>
    dispatch(themeRevertAction.sendThemeRevertContactOurTeamManual(body, ownProps.i18n)),
  unmountComponent: () => dispatch(themeRevertAction.unmountComponent()),
  resetForm: () => dispatch(reset('ContactOurTeamThemeRevert'))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ContactOurTeamThemeRevertModalForm));
